jQuery(document).ready(function(){
  /*
  $('.product-photo-thumbs li:first-child a').addClass('active');
  setTimeout(function(){
    //$('.zoomWindowContainer div').css('height', $('.product-single .product-photo-container').height() + 250);
    $('.zoomWindowContainer div').css('background-color', 'rgba(255, 255, 255)');
    //$('.zoomWindowContainer').css('width', $('#product-featured-image').width());
  }, 1000);
  */
  $('.collection_product_grid_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    arrows: true,
    pauseOnHover:true,
    focusOnSelect: true,
    touchThreshold: 100,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
  });
  /*
  $(".add_cart_btn").click(function(n) {
    n.preventDefault();
    if ($(this).attr("disabled") != "disabled") {
      var r = $(this).parents(".item-row");
      var i = $(r).attr("id");
      i = i.match(/\d+/g);
      if (!window.ajax_cart) {
        $("#cart-form-" + i).submit()
      } else {
        var s = $("#cart-form-" + i + " select[name=id]").val();                          
        if (!s) {
          s = $("#cart-form-" + i + " input[name=id]").val()
        }                          
        var o = $("#cart-form-" + i + " select[name=quantity]").val();
        if (!o) {
          o = 1
        }
        $("#cart-form-" + i).submit();
      }
    }
    return false;
  })
  */
    $('.home_page_full_width_grid').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      arrows: false,
      pauseOnHover:true,
      focusOnSelect: true,
      touchThreshold: 100,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  
  $('.collection_grid_slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: false,
      autoplay: true,
      centerMode: true,
      autoplaySpeed: 4000,
      infinite: true,
      arrows: false,
      pauseOnHover:true,
      focusOnSelect: true,
      touchThreshold: 100,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  $('.image_carasoual .slider').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    autoplay: true,
    autoplaySpeed: 9000,
    infinite: true,
    arrows: false,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      ]
    });
  
    $('.holiday_collection .widget .tag_heading').click(function() { 
      //$( ".holiday_collection .widget" ).each(function(){ $(this).removeClass('click');});
      
      //$(this).parent('.widget').toggleClass('click');
      //$(this).find(".widget-content").toggle();
      
     var $title = $(this).parents('.widget');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $( ".holiday_collection .widget" ).each(function(){ $(this).removeClass('click');});
                        $title.addClass('click');
                    }
      
    });
  	
  setTimeout(function() {
    $('.toogleClick').on('click', function(){
      
      var t_his = $(this);
      /*$('.toogleClick').each(function(){ 
        if($(this) != t_his) {
          $(this).removeClass('mobile-toggle-open');
          $(this).parent().find('.site-nav-dropdown').hide(); 
        }
      });*/
      t_his.toggleClass('mobile-toggle-open');
      //t_his.addClass('mobile-toggle-open');
      //t_his.parent().find('.site-nav-dropdown:first').show();
      if (t_his.hasClass('mobile-toggle-open')) {
        console.log('click');
        t_his.removeClass('mobile-toggle-open');
        //t_his.parent().find('.site-nav-dropdown').hide();
      } else {
        $( ".toogleClick" ).each(function(){
          if($(this) != t_his) {
          	$(this).removeClass('mobile-toggle-open');
            $(this).parent().find('.site-nav-dropdown:first').hide();
          }
          t_his.addClass('mobile-toggle-open');
      	  t_his.parent().find('.site-nav-dropdown:first').show();
        });
        t_his.addClass('mobile-toggle-open');
      }
    });
  }, 2000);
  
  var w = window.innerWidth;
  if (w < 768) {
    $('.product_image_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      autoplay: true,
      autoplaySpeed: 1500,
      infinite: true,
      arrows: true,
      pauseOnHover:true,
      focusOnSelect: true,
      touchThreshold: 100
    });
    
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      centeredSlides: false,
      slidesPerGroupSkip: 1,
      grabCursor: true,
      keyboard: { enabled: true },
      breakpoints: { 769: { slidesPerView: 1, slidesPerGroup: 1} },
      scrollbar: { el: '.swiper-scrollbar' },
      navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
      pagination: { el: '.swiper-pagination', clickable: true }
    });
  }
  
  setTimeout(function(){
    if (w < 967) {
      $('.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();
        var submenu = $(this).parent().find('.sub-menu');
        if ($(submenu).is(':hidden')) {
          $(submenu).show();
          $(this).find('.fa-caret-right').addClass('fa-caret-down').removeClass('fa-caret-right');
        } else {
          $(this).find('.fa-caret-down').addClass('fa-caret-right').removeClass('fa-caret-down');
          $(submenu).hide();
        }
      });
    }
  }, 2000);
  
  if (w > 470) {
    $('.slideshow.desktop_image').slick({
      dots: false,
      infinite: true,
      speed: 500,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      draggable: false,
      arrows: false
    });
  }
  
  if (w < 470) {
    $('.slideshow.mobile_image').slick({
      dots: false,
      infinite: true,
      speed: 500,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      draggable: false,
      arrows: false
    });
  }
  
  var myInterval = setInterval(function () {
    stories_width_incr();
  }, 1000);
  function stories_width_incr(){
    $('.template-collection .stories.list .story>a>.img').css({'height':'90px','width': '90px','max-width':'90px'});
    $('.template-collection .story-circle-gradient').css('align-self','center');
    if($('.template-collection .stories.list .story>a>.img').length > 0){
      clearInterval(myInterval);
    }
  }
});